/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_SwapInputs */

const en_us2_quick_workout_swap = /** @type {(inputs: Quick_Workout_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swap`)
};

const pt_br2_quick_workout_swap = /** @type {(inputs: Quick_Workout_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar`)
};

const es_419_quick_workout_swap = /** @type {(inputs: Quick_Workout_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar`)
};

const pt_pt2_quick_workout_swap = /** @type {(inputs: Quick_Workout_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar`)
};

const fr_fr2_quick_workout_swap = /** @type {(inputs: Quick_Workout_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacer`)
};

const de_de2_quick_workout_swap = /** @type {(inputs: Quick_Workout_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tauschen`)
};

const it_it2_quick_workout_swap = /** @type {(inputs: Quick_Workout_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia`)
};

/**
* | output |
* | --- |
* | "Swap" |
*
* @param {Quick_Workout_SwapInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_swap = /** @type {((inputs?: Quick_Workout_SwapInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_SwapInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_swap(inputs)
	if (locale === "es-419") return es_419_quick_workout_swap(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_swap(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_swap(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_swap(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_swap(inputs)
	return en_us2_quick_workout_swap(inputs)
});
export { quick_workout_swap as "quick-workout.swap" }